import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Select, MenuItem, FormControl, InputLabel } from '@mui/material';

interface EditMemberRoleModalProps {
  open: boolean;
  onClose: () => void;
  onSave: (memberId: string, newRole: string) => void;
  member: { id: string; name: string; currentRole: string } | null;
}

const EditMemberRoleModal: React.FC<EditMemberRoleModalProps> = ({ open, onClose, onSave, member }) => {
  const [selectedRole, setSelectedRole] = useState<string>('');

  useEffect(() => {
    if (member) {
      setSelectedRole(member.currentRole);
    }
  }, [member]);

  const handleSave = () => {
    if (member && selectedRole) {
      onSave(member.id, selectedRole);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Edit Role for {member?.name}</DialogTitle>
      <DialogContent>
        <FormControl fullWidth variant="outlined" sx={{ mt: 2 }}>
          <InputLabel id="edit-role-select-label">New Role</InputLabel>
          <Select
            labelId="edit-role-select-label"
            id="edit-role-select"
            value={selectedRole}
            onChange={(e) => setSelectedRole(e.target.value as string)}
            label="New Role"
          >
            <MenuItem value="OWNER">Owner</MenuItem>
            <MenuItem value="ADMIN">Admin</MenuItem>
            <MenuItem value="MEMBER">Member</MenuItem>
            <MenuItem value="VIEWER">Viewer</MenuItem>
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} variant="contained" color="primary">
          Save Changes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditMemberRoleModal;
